module.exports = __webpack_public_path__ + "static/media/shieldcomb.802f20f3.svg";